import { DEFAULT_LOCALE as BRAND_DEFAULT_LOCALE, LOCALES } from "@kupikupi/brand";

export const SUPPORTED_LOCALES = LOCALES as readonly ("ru" | "zh" | "en")[];

/** First entry of `LOCALES` env (per-env policy lives in `apps/web/.env.*`). */
export const DEFAULT_LOCALE: "ru" | "zh" | "en" = BRAND_DEFAULT_LOCALE;

export function isSupportedLocale(value: string): value is "ru" | "zh" | "en" {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function normalizeLocale(value: string): "ru-RU" | "zh-CN" | "en-US" {
  if (value.startsWith("zh")) return "zh-CN";
  if (value.startsWith("en")) return "en-US";
  return "ru-RU";
}
